export const VIEWPORT_WIDTH = 1600;
export const VIEWPORT_HEIGHT = 900;
export const ARENA_WIDTH = VIEWPORT_WIDTH * 2;
export const ARENA_HEIGHT = VIEWPORT_HEIGHT * 2;
export const MAX_PLAYERS = 75;
export const TICK_MS = 40;
export const SNAPSHOT_MS = 80;
export const REVIVE_DURATION_MS = 3_000;
export const REVIVE_SHIELD_DURATION_MS = 2_500;
export const LOOT_CHOICE_DURATION_MS = 12_000;
export const PERSONAL_CHALLENGE_COMPLETE_DISPLAY_MS = 2_500;
export const PERSONAL_CHALLENGE_REFRESH_MS = 7_000;
export const PLAYER_IDLE_TIMEOUT_MS = 30_000;
export const ULTIMATE_BARRAGE_CHARGES = 6;
export const REVIVE_RADIUS = 46;
export const XP_GAIN_MULTIPLIER = 1.5625;
export const MATCH_DURATION_MS = 10 * 60 * 1000;
export const BOSS_START_MS = 8 * 60 * 1000;
export const MINIBOSS_INTERVAL_MS = 45_000;
export const NAMED_ENEMY_REPEAT_MS = 35_000;
export const RESULTS_DURATION_MS = 30 * 1000;
export const MOTE_CAPACITY = 8;
export const MOTE_BANK_RADIUS = 92;
export const OVERDRIVE_DURATION_MS = 18_000;
export const FRENZY_SPEED_MULTIPLIER = 1.65;
export const FRENZY_XP_MULTIPLIER = 2;

export const ABILITIES = [
  "ember",
  "moon",
  "chain",
  "void",
  "frost",
  "solar",
  "raven",
  "necro",
  "bard",
] as const;
export type AbilityId = (typeof ABILITIES)[number];

export const ABILITY_NAMES: Record<AbilityId, string> = {
  ember: "Ember Wand",
  moon: "Moon Blades",
  chain: "Chain Spark",
  void: "Void Disc",
  frost: "Frost Halo",
  solar: "Solar Pulse",
  raven: "Raven Volley",
  necro: "Necromancer",
  bard: "Bard",
};

export const ABILITY_COLORS: Record<AbilityId, number> = {
  ember: 0xff7657,
  moon: 0xc7b8ff,
  chain: 0x69e7ff,
  void: 0xd86cff,
  frost: 0x78cfff,
  solar: 0xffcf57,
  raven: 0x9a7cff,
  necro: 0x75f0a0,
  bard: 0xff8fcb,
};

export const ULTIMATE_NAMES: Record<AbilityId, string> = {
  ember: "Inferno",
  moon: "Moonwell",
  chain: "Tempest",
  void: "Singularity",
  frost: "Absolute Zero",
  solar: "Supernova",
  raven: "Murder",
  necro: "Bone Legion",
  bard: "Grand Finale",
};

export const ULTIMATE_COOLDOWNS: Record<AbilityId, number> = {
  ember: 25_000,
  moon: 24_000,
  chain: 25_000,
  void: 27_000,
  frost: 27_000,
  solar: 30_000,
  raven: 24_000,
  necro: 28_000,
  bard: 30_000,
};
